import { forwardRef, memo, useImperativeHandle, useState } from 'react';
import { Field, FormikContextType, useField, useFormikContext } from 'formik';
import { Input, MLPVersion, useTranslation } from '@nextgen-web-framework/all';
import { AmwayPasswordInput, ComponentType } from '@commerce-identity-webcomponents/ui';
import { PasswordFieldProps, RegisterationPasswordRef, UsernameFormikContextValues } from './types/propTypes';

const PasswordField = forwardRef<RegisterationPasswordRef, PasswordFieldProps>((props, ref) => {
  const { isRefreshRestoredData, identityChangedAfterPreview } = props;
  const { status, handleChange, values }: FormikContextType<UsernameFormikContextValues> = useFormikContext();
  const t = useTranslation();
  const [, passwordMeta, passwordHandler] = useField('password');
  const [passwordError, setPasswordError] = useState('');

  useImperativeHandle(ref, () => ({
    validatePassword: () => {
      setPasswordError(passwordMeta?.error || '');
    },
    resetPassword: () => {
      setPasswordError('');
      passwordHandler.setValue('');
    },
  }));

  return isRefreshRestoredData && !identityChangedAfterPreview ? (
    <Input
      type="password"
      label={t('identity.CreateAmwayId.passwordPlaceholder')}
      name={'password'}
      value={'*********'}
      disabled
    />
  ) : (
    <Field name="password" as="text">
      {() => (
        <AmwayPasswordInput
          name="createPassword"
          mlpVersion={MLPVersion.ONE}
          label={t('identity.CreateAmwayId.passwordPlaceholder')}
          onInputChangeCallback={(e) => {
            handleChange(e);
            setPasswordError('');
          }}
          onPasswordMeetsMinimumChange={(meetsMinimum) => {
            meetsMinimum ? passwordHandler.setValue(values?.createPassword) : passwordHandler.setValue('');
          }}
          component={ComponentType.WITHOUT_CONFIRM}
          disabled={!status?.enableField}
          error={status?.enableField && passwordError ? t(passwordError) : ''}
          setError={setPasswordError}
          value={{ createPassword: values?.createPassword ?? '', confirmPassword: '' }}
          forceError={status?.enableField ? !!passwordError : false}
          required={false}
        />
      )}
    </Field>
  );
});
PasswordField.displayName = 'PasswordField';
export default memo(PasswordField);
